function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { node, string, bool } from 'prop-types';
import cn from 'classnames';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import { useDesignTokens } from '../../hooks';
/**
 * BackgroundContainer component.
 */

var BackgroundContainer = function BackgroundContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hasTopBorder = _ref.hasTopBorder,
      hasBottomBorder = _ref.hasBottomBorder;

  var _useDesignTokens = useDesignTokens(),
      colors = _useDesignTokens.colors;

  return /*#__PURE__*/React.createElement("div", {
    className: cn('background-container', className),
    style: _objectSpread({}, color && {
      backgroundColor: colors[color]
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cn("background-container__inner container--no-gutters", className),
    style: _objectSpread(_objectSpread(_objectSpread({}, color && {
      backgroundColor: colors[color]
    }), hasTopBorder && {
      marginTop: -1
    }), hasBottomBorder && {
      marginBottom: -1
    })
  }, children));
};

BackgroundContainer.defaultProps = {
  children: null,
  className: '',
  color: null,
  hasTopBorder: false,
  hasBottomBorder: false
};
BackgroundContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Children to be rendered inside the BackgroundContainer component. */
  children: node,

  /** Additional classes to be added to the root of the component. */
  className: string,

  /** Background colour of the component. */
  color: designTokenPropTypes.color,

  /** Border top style by 1px of the inner container if true. */
  hasTopBorder: bool,

  /** Border bottom style by 1px of the inner container if true. */
  hasBottomBorder: bool
} : {};
export default BackgroundContainer;